import { FETCH_CONVERSATION_BEGIN,
    FETCH_CONVERSATION_SUCCESS,
    FETCH_CONVERSATION_FAILURE,
    ADD_MESSAGE_BEGIN,
    ADD_MESSAGE_SUCCESS,
    ADD_MESSAGE_FAILURE,
    DELETE_MESSAGE_BEGIN,
    DELETE_MESSAGE_SUCCESS,
    DELETE_MESSAGE_FAILURE
  } from '../actions/conversation';

export default function conversation(state = {}, action) {
  let objects_state, messages, query, previousState;
  if (action.opts) {
    previousState = state[action.opts.relatedObject];
    if (!previousState) {
      previousState = {
        messages: [],
        query: {},
        isLastPage: false,
        loading: false,
        error: null
      };
    }
  }
  switch (action.type) {
  case FETCH_CONVERSATION_BEGIN:
        // Mark the state as "loading" so we can show a spinner or something
        // Also, reset any errors. We're starting fresh.
    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: true,
      error: null
    };
    return {
      ...state,
      ...objects_state
    };

  case FETCH_CONVERSATION_SUCCESS:
        // All done: set loading "false".
        // Also, replace the items with the ones from the server
    let conversationResponse = action.payload.drafts;
    messages = (action.opts.concat ? conversationResponse.messages.reverse().concat(previousState.messages) : conversationResponse.messages.reverse());
    query = { ...previousState.query, ...action.opts.query, cursor: conversationResponse.cursor, nextCursor: conversationResponse.next_cursor };
    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: false,
      messages,
      isLastPage: conversationResponse.last_page,
      query,
      error: null
    };
    return {
      ...state,
      ...objects_state
    };

  case FETCH_CONVERSATION_FAILURE:
        // The request failed, but it did stop, so set loading to "false".
        // Save the error, and we can display it somewhere
        // Since it failed, we don't have items to display anymore, so set it empty.
        // This is up to you and your app though: maybe you want to keep the items
        // around! Do whatever seems right.
    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: false,
      error: action.payload.error
    };
    return {
      ...state,
      ...objects_state
    };

  case ADD_MESSAGE_BEGIN:

    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: true,
      error: null
    };
    return {
      ...state,
      ...objects_state
    };

  case ADD_MESSAGE_SUCCESS:
        // All done: set loading "false".
        // Also, replace the items with the ones from the server
    messages = previousState.messages;
    if (action.message.message) {
      messages.push(action.message.message);
    }
    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: false,
      messages,
    };

    return {
      ...state,
      ...objects_state
    };

  case DELETE_MESSAGE_FAILURE:
    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: false,
      error: action.payload.error
    };
    return {
      ...state,
      ...objects_state
    };
  case DELETE_MESSAGE_BEGIN:

    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: true,
      error: null
    };
    return {
      ...state,
      ...objects_state
    };

  case DELETE_MESSAGE_SUCCESS:
        // All done: set loading "false".
        // Also, replace the items with the ones from the server
    messages = previousState.messages;
    if (action.message.id && action.message.deleted) {
      messages = messages.filter((message) => message.id != action.message.id);
    }
    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: false,
      messages,
    };

    return {
      ...state,
      ...objects_state
    };

  case ADD_MESSAGE_FAILURE:
    objects_state = {};
    objects_state[action.opts.relatedObject] = {
      ...previousState,
      loading: false,
      error: action.payload.error
    };
    return {
      ...state,
      ...objects_state
    };
  default:
        // ALWAYS have a default case in a reducer
    return state;
  }

}
